import React, { Component } from 'react';
import { Field } from 'formik';
import { Button, message } from 'antd';
import * as yup from 'yup';
import { asyncConnect } from 'react-async-client';

import PageForm from 'components/common/PageForm';
import Input from 'components/common/form/Input';
import SwitchInput from 'components/common/form/SwitchInput';
import HeadBlock from 'components/common/cards/HeadBlock';
import Spinner from 'components/common/Spinner';
import { DEFAULT_PHOTO_REPORT_SETTINGS } from 'constants/photoReports';
import {
    formAutoOptions,
    getPhotoReportSettings,
    putPhotoReportSettings,
} from 'actions/asyncActions';

const typeSchema = yup.object().shape({
    name: yup.string().trim().required(),
    photosLabel: yup.string().trim().required(),
    additionalPhotosLabel: yup.string().trim().required(),
    commentLabel: yup.string().trim().required(),
    additionalCommentLabel: yup.string().trim().required(),
});

@asyncConnect({
    getPhotoReportSettings: getPhotoReportSettings,
    putPhotoReportSettings: putPhotoReportSettings
        .withSuccessHandler(({ getPhotoReportSettings }, action) => {
            message.success('Настройки успешно сохранены.');
            if (action.payload) {
                getPhotoReportSettings.success(action.payload);
            }
        })
        .withOptions(formAutoOptions),
})
export default class PhotoReportsSettings extends Component {
    getValidationSchema() {
        return yup.object().shape({
            enabled: yup.boolean(),
            omp: typeSchema,
            dmp: typeSchema,
        });
    }

    renderTypeFields = (prefix, title) => (
        <div className='mt15'>
            <h3>{title}</h3>
            <Field name={`${prefix}.name`} component={Input} label='Название отчета' />
            <Field name={`${prefix}.photosLabel`} component={Input} label='Название поля фото' />
            <Field name={`${prefix}.additionalPhotosLabel`} component={Input} label='Название поля дополнительного фото' />
            <Field name={`${prefix}.commentLabel`} component={Input} label='Название поля комментария' />
            <Field name={`${prefix}.additionalCommentLabel`} component={Input} label='Название поля дополнительного комментария' />
        </div>
    );

    renderForm = ({ isSubmitting, handleSubmit }) => (
        <div>
            <Field
                name='enabled'
                component={SwitchInput}
                label='Фотоотчеты включены'
            />
            {this.renderTypeFields('omp', 'ОМП')}
            {this.renderTypeFields('dmp', 'ДМП')}
            <Button
                type='primary'
                htmlType='submit'
                disabled={isSubmitting}
                onClick={handleSubmit}
            >
                Сохранить
            </Button>
        </div>
    );

    render() {
        const { getPhotoReportSettings: { data, meta }, putPhotoReportSettings } = this.props;

        if (!data.id && !meta.success && !meta.error) {
            return <Spinner />;
        }

        return (
            <div className='sales-form'>
                <HeadBlock title='Настройки фотоотчетов' hideBack />
                <PageForm
                    initialValues={{
                        ...DEFAULT_PHOTO_REPORT_SETTINGS,
                        ...data,
                        omp: { ...DEFAULT_PHOTO_REPORT_SETTINGS.omp, ...(data.omp || {}) },
                        dmp: { ...DEFAULT_PHOTO_REPORT_SETTINGS.dmp, ...(data.dmp || {}) },
                    }}
                    validationSchema={this.getValidationSchema()}
                    formAction={putPhotoReportSettings}
                    mapBeforeSubmit={values => ({
                        enabled: values.enabled,
                        omp: values.omp,
                        dmp: values.dmp,
                    })}
                    renderForm={this.renderForm}
                />
            </div>
        );
    }
}
